import { render, staticRenderFns } from "./SegmentIcon.vue?vue&type=template&id=4e5f1e34&scoped=true&"
import script from "./SegmentIcon.vue?vue&type=script&lang=js&"
export * from "./SegmentIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5f1e34",
  null
  
)

export default component.exports